import React from 'react';
import Compensatory_Leave from './Compensatory_Leave';
import '../../../CommonCSS/SocietyCSS.css';

const Compensatory_LeaveApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Compensatory/Visiting Leave Application</h5>
          </div>
        </div>
        <Compensatory_Leave />
      </div>
    </div >
  );
};

export default Compensatory_LeaveApp;
